import Button from 'react-bootstrap/Button';

export default (props: any) => {
    return (
        <Button
            size="sm"
            variant="danger">
            Remove
        </Button>
    );
};
